import React, { useState, useEffect } from 'react';
import getImages from "../../constants/images";

const SpinningWheel = ({ isVisible }) => {
  const images = getImages();
  
  const [currentFace, setCurrentFace] = useState(images.faces.wink);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFace(prevFace =>
        prevFace === images.faces.wink ? images.faces.happy : images.faces.wink
      );
    }, 1500);

    return () => clearInterval(interval);
  }, [images.faces.happy, images.faces.wink]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <img
        src={currentFace}
        alt="Spinning"
        className="h-24 w-24 animate-spin bg-white rounded-full p-1"
        style={{ animationDuration: '1.5s' }}
      />
    </div>
  );
};

export default SpinningWheel;